export default function Products(){
    return(
        <></>
    )
}